import { Controller } from "@hotwired/stimulus"

// The dashboard's top strips as one horizontal rail
// (budgets/_budget_content_panel). Scrolling, snapping and the widths are all
// CSS (.strip-rail in budgets/index) — there is no swipe handling here and no
// pager.
//
// The one thing CSS cannot answer is how many strips this device actually
// has. What's new and the recap teaser are rendered on every request and
// remove themselves on connect when localStorage says they were dismissed
// (dismissible_controller), so the server's count is only an upper bound. One
// strip left means it stops peeking and fills the rail.
//
// A MutationObserver rather than a dismissal event: strips leave two
// different ways — remembered, at connect, and animated, later — and childList
// catches both without either side having to announce anything.
export default class extends Controller {
  connect() {
    this.observer = new MutationObserver(() => this.#sync())
    this.observer.observe(this.element, { childList: true })
    this.#sync()
  }

  disconnect() {
    this.observer?.disconnect()
    this.observer = null
  }

  // is-empty as well as is-single, because the rail can end up with nothing in
  // it at all: the server renders what's new and the recap teaser on every
  // request and both remove themselves here when localStorage says they were
  // dismissed, so an account with no goal and no streak nudge is left with an
  // empty rail. The rail's own box is already net-zero (see .strip-rail), but
  // the section under it is still paying a 32px gap to a row that is no longer
  // there, on top of the 32 the budget card's dots band already paid. The class
  // lets that section go flush (.strip-rail.is-empty + * in budgets/index).
  #sync() {
    this.element.classList.toggle("is-single", this.element.childElementCount <= 1)
    this.element.classList.toggle("is-empty", this.element.childElementCount === 0)
  }
}
